<template>
  <div class="documents-report-table">
    <loader
      v-if="loading"
      class="documents-report-table__loader"
      :class="{
        cover: workers.length,
      }"
      :active="loading"
      label="Данные загружаются"
      height="300"
    />

    <horizontal-table
      v-if="workers.length"
      :fix-header="true"
      class="documents-report-table__table"
      @nextPage="$emit('nextPage')"
    >
      <table class="h-table" :fix-header="true">
        <tbody>
          <tr>
            <th>ФИО</th>

            <td v-for="worker in workers" :key="worker.id">
              <router-link
                :to="{
                  name: 'personal-employee-documents',
                  params: { id: worker.id },
                  query: { tab: 'medical_documents' },
                }"
              >
                {{ worker.name }}
              </router-link>
            </td>
          </tr>

          <tr>
            <th>Филиал</th>

            <td v-for="worker in workers" :key="worker.id">
              {{ worker.filial }}
            </td>
          </tr>

          <tr>
            <th>Должность</th>

            <td v-for="worker in workers" :key="worker.id">
              <div v-for="position in worker.positions" :key="position">
                {{ position }}
              </div>
            </td>
          </tr>
        </tbody>

        <template v-for="group in filteredAnalyseGroups.filter((item) => item.analyses.length)">
          <tr :key="group.id + '-header'" class="documents-group">
            <th>
              <div class="title">
                {{ group.name }}
                <div v-b-toggle="'group-toggler-' + group.id" class="toggler">
                  <svg-icon name="chevron-top-circled" :size="22" color="primary" class="toggler-icon"></svg-icon>
                </div>
              </div>
            </th>

            <td v-for="worker in workers" :key="worker.id"></td>
          </tr>

          <b-collapse
            :id="'group-toggler-' + group.id"
            :key="group.id + '-items'"
            tag="tbody"
            class="documents-group-items"
          >
            <tr v-for="analyse in group.analyses" :key="group.id + '-analyse-' + analyse.id" class="documents-item">
              <th>
                <span>{{ analyse.name }}</span>
              </th>

              <analyse-status
                v-for="worker in workers"
                :key="worker.id"
                :worker="worker"
                :group-id="group.id"
                :analyse-id="analyse.id"
              />
            </tr>
          </b-collapse>
        </template>
      </table>
    </horizontal-table>

    <div v-if="inited && !loading && !workers.length" class="documents-report-table__empty">
      Ничего не найдено. Попробуйте изменить параметры поиска.
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import HorizontalTable from "@/components/horizontal-table";
import Loader from "@/components/loader";
import SvgIcon from "@/components/svg-icon";
import AnalyseStatus from "./analyse-status";
import { filterAnalyseByExpirationType } from "../../../../helpers/medicalAnalysesReportHelper";

export default {
  name: "medical-analyses-report-table",

  components: {
    HorizontalTable,
    Loader,
    SvgIcon,
    AnalyseStatus,
  },

  props: ["workers", "loading", "inited", "filters"],

  computed: {
    ...mapGetters({
      analyseGroups: "medicalAnalysesForm/getAnalysesTypesRaw",
    }),
    filteredAnalyseGroups() {
      const filteredGroups = [];

      /**
       * @TODO Refactor this shit
       */

      const analyseTypeFilters = ["medicalAnalysesTypeIds", "medicalAnalysesTypeIdsExcept"];
      const analyseFilters = ["medicalAnalysesIds"];
      const expirationFilters = ["expirationType", "expireInDaysTo"];

      const filterParams = {};

      this.filters.forEach(({ name, values }) => {
        if (analyseTypeFilters.includes(name)) {
          filterParams.analyseType = {
            except: name.includes("Except"),
            values,
          };
        }
        if (analyseFilters.includes(name)) {
          filterParams.analyse = {
            except: name.includes("Except"),
            values,
          };
        }
        if (expirationFilters.includes(name)) {
          if (name === "expireInDaysTo") {
            filterParams.expireInDays = {
              to: values[0],
              from: this.filters.find((item) => item.name === "expireInDaysFrom").values[0],
            };
            return;
          }
          filterParams[name] = {
            values,
          };
        }
      });

      const groupsMap = {};

      this.analyseGroups.forEach(({ name, id, analyses, sort }) => {
        if (!groupsMap[id]) {
          groupsMap[id] = {
            id,
            name,
            analyses: {},
            sort,
          };
        }
        if (analyses) {
          analyses.forEach((analyse) => {
            groupsMap[id].analyses[analyse.id] = analyse;
          });
        }
      });

      const filteredByWorkerGroupIds = {};

      this.workers.forEach(({ analyseGroups }) => {
        if (analyseGroups.length) {
          analyseGroups.forEach((group) => {
            if (
              filterParams.analyseType &&
              !filterParams.analyseType.except &&
              !filterParams.analyseType.values.includes(group.id)
            ) {
              return;
            }
            if (
              filterParams.analyseType &&
              filterParams.analyseType.except &&
              filterParams.analyseType.values.includes(group.id)
            ) {
              return;
            }

            if (!filteredByWorkerGroupIds[group.id]) {
              filteredByWorkerGroupIds[group.id] = [];
            }

            if (group.analyses.length) {
              group.analyses.forEach((analyse) => {
                if (
                  filterParams.analyse &&
                  !filterParams.analyse.except &&
                  !filterParams.analyse.values.includes(analyse.id)
                ) {
                  return;
                }
                if (
                  filterParams.analyse &&
                  filterParams.analyse.except &&
                  filterParams.analyse.values.includes(analyse.id)
                ) {
                  return;
                }

                if (filterParams.expirationType) {
                  let isPassed = true;

                  const filters = filterParams.expirationType.values;

                  for (let i = 0; i < filters.length; i++) {
                    if (!filterAnalyseByExpirationType[filters[i]](analyse)) {
                      isPassed = false;
                      break;
                    }
                  }

                  if (!isPassed) {
                    return;
                  }
                }

                if (filterParams.expireInDays) {
                  if (!this.isExpireMatchedAnalyse(filterParams.expireInDays, group.id, analyse.id)) {
                    return;
                  }
                }

                if (!filteredByWorkerGroupIds[group.id].includes(analyse.id)) {
                  filteredByWorkerGroupIds[group.id].push(analyse.id);
                }
              });
            }
          });
        }
      });

      Object.entries(filteredByWorkerGroupIds).forEach(([groupId, groupAnalyses]) => {
        const filteredAnalyses = [];

        groupAnalyses.forEach((analyseId) => {
          filteredAnalyses.push(groupsMap[groupId].analyses[analyseId]);
        });

        filteredGroups.push({
          ...groupsMap[groupId],
          analyses: filteredAnalyses.sort((a, b) => b.sort - a.sort),
        });
      });

      return filteredGroups.sort((a, b) => b.sort - a.sort);
    },
  },

  methods: {
    isExpireMatchedAnalyse({ to, from }, groupId, analyseId) {
      let isMatched = false;
      this.workers.forEach((worker) => {
        worker.analyseGroups.forEach((group) => {
          if (group.id !== groupId) {
            return;
          }
          group.analyses.forEach((analyse) => {
            if (analyse.id !== analyseId) {
              return;
            }
            if (!analyse.expireInfo) {
              return;
            }
            const { daysLeft } = analyse.expireInfo;
            if (daysLeft >= from && daysLeft <= to) {
              isMatched = true;
            }
          });
        });
      });

      return isMatched;
    },
  },
};
</script>

<style lang="scss" scoped src="../scss/table.scss"></style>
